const storeUTMAndSource = () => {
	const urlParams = new URLSearchParams(window.location.search);
	const referrer = document.referrer;
	const currentDomains = [window.location.hostname, 'secureacceptance.cybersource.com'];

	//UTM Parameters
	const utmParams = {
		utm_source: urlParams.get("utm_source"),
		utm_medium: urlParams.get("utm_medium"),
		utm_campaign: urlParams.get("utm_campaign"),
		utm_term: urlParams.get("utm_term"),
		utm_content: urlParams.get("utm_content"),
	};

	const expiryTime = new Date();
	expiryTime.setTime(expiryTime.getTime() + 7 * 24 * 60 * 60 * 1000); // 7 days

	const getCookie = (name) =>
		document.cookie
			.split("; ")
			.find((row) => row.startsWith(name + "="));

	//Handle UTM Cookie
	const hasUtmValues = Object.values(utmParams).some(
		(v) => v && v !== "null" && v !== "undefined"
	);
	const existingUtm = getCookie("donation_utm");

	if (!existingUtm && hasUtmValues) {
		const utmData = {
			utm_date: new Date().toUTCString(),
			...utmParams,
		};
		const encodedUtm = encodeURIComponent(JSON.stringify(utmData));
		document.cookie = `donation_utm=${encodedUtm}; expires=${expiryTime.toUTCString()}; path=/;`;
	}

	//Handle Source Cookie
	const referrerHostname = referrer ? new URL(referrer).hostname : null;
    const isExternalReferrer = referrerHostname && !currentDomains.includes(referrerHostname);
	const existingSource = getCookie("donation_source");
    
	if (!existingSource && isExternalReferrer) {
		const sourceData = {
			source_url: referrer,
			source_date: new Date().toUTCString(),
		};
		const encodedSource = encodeURIComponent(JSON.stringify(sourceData));
		document.cookie = `donation_source=${encodedSource}; expires=${expiryTime.toUTCString()}; path=/;`;
	}
};

const decodeSourceCookie = () => {
    const cookie = document.cookie
        .split(';')
        .map((cookie) => cookie.trim())
        .find((cookie) => cookie.startsWith('donation_source='));

    if (cookie) {
        const sourceCookieValue = cookie.split('=')[1];
        return JSON.parse(decodeURIComponent(sourceCookieValue));
    }

    return null;
}

const collectSourceURL = () => {
    const sourceCookie = decodeSourceCookie();

    if (sourceCookie && sourceCookie.referrer) {
        const referrerURL = new URL(sourceCookie.referrer);

        return referrerURL.href;
    }

    return null; // Return 'Direct' if sourceCookie or referrer is unavailable
}

const collectSourceDate = () => {
    const sourceCookie = decodeSourceCookie();
    const sourceURL = collectSourceURL();

    if (sourceCookie && sourceCookie.dateRecorded && sourceCookie.dateRecorded && sourceURL) {
        return sourceCookie.dateRecorded;
    }

    return null; // Return current date if dateRecorded is unavailable
}

export {storeUTMAndSource, decodeSourceCookie, collectSourceURL, collectSourceDate} ;
